var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_left_26x48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5277 23.3322C11.6486 23.3322 11.7695 23.2859 11.8615 23.1938C12.0462 23.0092 12.0462 22.7108 11.8615 22.5262L1.33536 12L11.8615 1.47384C12.0462 1.28922 12.0462 0.99081 11.8615 0.80619C11.6769 0.62157 11.3785 0.62157 11.1939 0.80619L5.72205e-05 12L11.1939 23.1938C11.286 23.2859 11.4068 23.3322 11.5277 23.3322Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.679089c978106227c40e82c1398dfda1.svg";
export { ForwardRef as ReactComponent };